var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('glp-file-viewer',{attrs:{"name":"阿里云图片文件.jpg","title":"营业付个问问呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜份额飞飞飞微风服务费而分为王菲菲执照","url":"http://glp-common.oss-cn-shanghai.aliyuncs.com/tmp/0518d981-b53b-4dc3-8f0a-70f40f4e441c.jpg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }